import Setting from "@app/analytics/account/components/Setting";

import { Column } from "@rui/Stack";

import MeetingLinkSetting from "./MeetingLinkSetting";
import MeetingReportDistributionSettings from "./MeetingReportDistributionSettings";
import PreReadDistributionSettings from "./PreReadDistributionSettings";
import UpdateCalendarEventSettings from "./UpdateCalendarEventSettings";

const ReportDistributionSettings = () => {
  return (
    <Setting title="Report Distribution">
      <Column spacing={2} paddingTop={0.5} paddingLeft={0.5}>
        <MeetingReportDistributionSettings />
        <PreReadDistributionSettings />
        <MeetingLinkSetting />
        <UpdateCalendarEventSettings />
      </Column>
    </Setting>
  );
};

export default ReportDistributionSettings;
